<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UserMenu',
})
</script>
<template>
  <div class="user-wrapper">
    <div class="content-box">
      <notice-icon class="action" />
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <!-- <a-avatar class="avatar" size="small" :src="UserInfo.avatar" /> -->
          <a-avatar class="avatar" size="small" :src="'https://picsum.photos/200'" />
          <span class="nickname">{{ UserInfo.nickName }}</span>
        </span>
        <template #overlay>
          <a-menu class="user-dropdown-menu-wrapper">
            <!-- <a-menu-item key="0">
            <router-link :to="{ name: 'center' }">
              <a-icon type="user" />
              <span>个人中心</span>
            </router-link>
            </a-menu-item>-->
            <!-- <a-menu-item key="1">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="setting" />
              <span>账户设置</span>
            </router-link>
            </a-menu-item>-->
            <a-menu-item key="4" @click="showSystemSetting">
              <a>
                <SettingOutlined />
                <span>{{ $t('tools.userMenu.systemConfig') }}</span>
              </a>
            </a-menu-item>
            <!-- <a-menu-item key="2" disabled>
              <SettingOutlined />
              <span>{{ $t('tools.userMenu.test') }}</span>
            </a-menu-item>-->
            <a-menu-divider />
            <a-menu-item key="3">
              <a href="javascript:;" @click="handleLogout">
                <LogoutOutlined />
                <span>{{ $t('tools.userMenu.logout') }}</span>
              </a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <span style="overflow: hidden; display: inline-block">
        <SelectLang :class="theme" class="action" />
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup name="UserMenu">
import NoticeIcon from '@/components/NoticeIcon/index.vue'
// import { logout } from '@/views/user/service' // 此处后面要用framework中引入logout
import { USER_INFO } from '@/store/mutation-types'
import { Modal } from 'ant-design-vue'
import { QuestionCircleOutlined, SettingOutlined, LogoutOutlined, LockOutlined } from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'
import { systemConfig } from '@/store/reactiveState'
import SelectLang from '@/components/SelectLang'
import ls from '@/utils/Storage'
import { useRouter } from 'vue-router'
import { clearUserInfo } from '@/utils/util'
import { useAuthStore } from '@admin-base/core'
import { message } from 'ant-design-vue'
const useAuth = useAuthStore()
const props = defineProps(['theme'])
const { t } = useI18n()
const router = useRouter()
let UserInfo = ls.get(USER_INFO)
UserInfo = UserInfo ? JSON.parse(UserInfo) : {}
console.log('UserInfo', UserInfo)
const handleLogout = () => {
  Modal.confirm({
    title: t('tools.userMenu.tip'),
    content: t('tools.userMenu.checkLogout'),
    onOk: () => {
      const v = localStorage.getItem('operationsterminal')
      useAuth.logout()
      router.push({ path: '/login' })
      message.success('退出成功')
      if (v) {
        localStorage.setItem('operationsterminal', v)
      }
    },
    onCancel() {}
  })
}
const showSystemSetting = () => {
  systemConfig.commit('SET_SETTING_DRAWER', true)
}
</script>
<style lang="less">
.user-dropdown-menu-wrapper {
  .ant-dropdown-menu-item {
    width: 100% !important;
  }
}
</style>
